import Link from 'next/link';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import ErrorSvg from '@/assets/icons/502.svg';
import s from './ErrorPage.module.scss';

export const ErrorPage = () => {
  return (
    <section className={s.error}>
      <div className={`${s.error__container} custom-container`}>
        <ErrorSvg className={s.error__svg} />
        <p className={s.error__text}>
          <span>Сервер не отвечает...</span><br />
          Перезагрузите страницу или попробуйте снова через некоторое время
        </p>
        <span className={s.error__nginx}>nginx/ 1.2.6</span>
        <Link href={'/'}>
          <ActionButton isDivElement>
            Вернуться на Главную
          </ActionButton>
        </Link>
      </div>
    </section>
  );
};